const animation = require("./round8.json");

module.exports = {
    loop: false,
    autoplay: false,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'none'
    },
}